// 1st edition code 


// import React, { useState} from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SECURITY_KEY } from "../../../globals"; 

// const Updateuser = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const initialData = location.state?.responseData || {};

//   const [editableData, setEditableData] = useState(initialData);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditableData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };


//   const handleSaveChanges = async () => {
//   if (!editableData.ID || !editableData.LoginID) {
//     toast.warn("ID and LoginID are required.");
//     return;
//   }

//   const  changes = Object.entries(editableData)
//     .filter(([key, value]) => key !== "ID" && value !== initialData[key])
//     .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
//     .join("&");
//   console.log("📦 Updated User Data Being Sent:", editableData)
//   console.log("📦 Changes to be sent:", changes

//   );
//   if (changes.length === 0) {
//     toast.warn("No changes detected.");
//     return;
//   }

//   const formData = new URLSearchParams();
//   formData.append("SecurityKey", SECURITY_KEY);
//   formData.append("TableName", "users");
//   formData.append("WhereCondition", `ID=${editableData.ID}`);

//   // Append updated fields
//   Object.entries(editableData).forEach(([key, value]) => {
//     if (key !== "ID") {
//       formData.append(key, value);
//     }
//   });

//   try {
//     const response = await fetch("https://etour.responseinfoway.com/restapi/updatedata.aspx", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//       body: formData.toString(),
//     });

//     const textResponse = await response.text();

//     if (textResponse.includes("Ok")) {
//       toast.success("User updated successfully!");
//       navigate("/users");
//     } else {
//       toast.error("❌ Update failed.");
//     }
//   } catch (error) {
//      toast.success("✅ User updated successfully!");
//       navigate("/users");
//   }
// };

 



//   return (
//     <div className="update-container mt-3 mb-3">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
//       <h1>🔄 Update User</h1>

//       <form>
//         <div className="input-group">
//           <label>Login ID</label>
//           <input
//             type="text"
//             name="LoginID"
//             value={editableData.LoginID || ""}
//             onChange={handleInputChange}
//           />
//         </div>

//         <div className="input-group">
//           <label>Password</label>
//           <input
//             type="text"
//             name="Password"
//             value={editableData.Password || ""}
//             onChange={handleInputChange}
//           />
//         </div>

//         <div className="input-group d-none">
//           <label>User Type</label>
//           <input
//             type="text"
//             name="UserType"
//             value={editableData.UserType || ""}
//             onChange={handleInputChange}
//           />
//         </div>

//         <div className="input-group d-none">
//           <label>Active</label>
//           <select
//             name="Active"
//             value={editableData.Active || "1"}
//             onChange={handleInputChange}
//           >
//             <option value="1">Active</option>
//             <option value="0">Inactive</option>
//           </select>
//         </div>

//         <button
//           type="button"
//           className="save-changebtn mt-2"
//           onClick={handleSaveChanges}
//         >
//           ✅ Save Changes
//         </button>
//       </form>
//     </div>
//   );
// };

// export default Updateuser;









import React, { useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import { SECURITY_KEY } from "../../../globals";
import { apiWithLog } from "../../../utils/apiWithLog";
import "../Ledger/UpdateLedger.css";

const Updateuser = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialData = location.state?.responseData || {};
  const [editableData, setEditableData] = useState(initialData);
  const [showPassword, setShowPassword] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSaveChanges = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (loading) return;

    if (!editableData.ID || !editableData.LoginID) {
      showToast.warn("ID and LoginID are required.");
      return;
    }

    const changes = Object.entries(editableData)
      .filter(([key, value]) => key !== "ID" && value !== initialData[key])
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");

    console.log("📦 Updated User Data Being Sent:", editableData);
    console.log("📦 Changes to be sent:", changes);

    if (changes.length === 0) {
      showToast.warn("No changes detected.");
      return;
    }

    try {
      setLoading(true);
      const res = await apiWithLog({
        method: "PUT",
        url: `${BASE_API_URL}/user/${editableData.ID}`,
        data: editableData,
        module: "User",
        action: "E",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = res.data;
      console.log("Update API Response:", result);

      if (
        res.status === 200 &&
        (result?.message?.toLowerCase().includes("success") ||
          result?.status === true ||
          result?.status === "ok")
      ) {
        showToast.save("User updated successfully!");
        setSuccessMessage("User updated successfully!");

        setTimeout(() => {
          navigate("/users");
        }, 1200);
      } else {
        showToast.error(result?.message || "Update failed.");
      }
    } catch (error) {
      console.error("Update error:", error);
      showToast.error(
        error?.response?.data?.message ||
        "Update failed due to server error."
      );
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="update_ledger_container">
      {/* Header & Breadcrumbs */}
      <div className="update_ledger_header_bar">
        <div className="update_ledger_title_group">
          <h4 className="update_ledger_title">Update User</h4>
          <div className="update_ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <Link to="/users">Users</Link>
            <span>/</span>
            <span>Update</span>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <div className="update_ledger_card">
        <div className="update_ledger_card_header">
          <h5>User Information</h5>
        </div>

        <form onSubmit={(e) => { e.preventDefault(); handleSaveChanges(); }}>
          <div className="update_ledger_grid">
            {/* Login ID */}
            <div className="update_ledger_field">
              <label htmlFor="LoginID">
                Login ID <span className="required">*</span>
              </label>
              <input
                id="LoginID"
                type="text"
                name="LoginID"
                value={editableData.LoginID || ""}
                onChange={handleInputChange}
                placeholder="Enter Login ID"
                required
              />
            </div>

            {/* Password */}
            <div className="update_ledger_field">
              <label htmlFor="Password">
                Password <span className="required">*</span>
              </label>
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <input
                  id="Password"
                  type={showPassword ? "text" : "password"}
                  name="Password"
                  value={editableData.Password || ""}
                  onChange={handleInputChange}
                  placeholder="Enter Password"
                  required
                  style={{ width: "100%", paddingRight: "36px" }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  title={showPassword ? "Click to hide password" : "Click to view password"}
                  style={{
                    position: "absolute",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    color: showPassword ? "#0d9488" : "#64748b",
                    cursor: "pointer",
                    padding: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  tabIndex="-1"
                >
                  <i className={showPassword ? "fa-solid fa-eye" : "fa-solid fa-eye-slash"}></i>
                </button>
              </div>
            </div>

            {/* Hidden User Type */}
            <div className="update_ledger_field d-none">
              <label>User Type</label>
              <input
                type="text"
                name="UserType"
                value={editableData.UserType || ""}
                onChange={handleInputChange}
              />
            </div>

            {/* Hidden Active Field */}
            <div className="update_ledger_field d-none">
              <label>Active</label>
              <select
                name="Active"
                value={editableData.Active || "1"}
                onChange={handleInputChange}
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
          </div>

          <div className="update_ledger_actions">
            <Link to="/users" className="update_ledger_cancel_btn">
              Cancel
            </Link>
            <button
              type="submit"
              className="update_ledger_submit_btn"
              disabled={loading}
            >
              {loading ? "Saving Changes..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Updateuser;
